import { mapState, mapGetters, mapActions } from "vuex"

export const authComputed = {
  ...mapState("auth", {
    sessionObject: (state) => state.sessionObject,
  }),
  ...mapGetters("auth", ["sessionObject", "users", "networks", "groups"]),
}

export const authMethods = mapActions("auth", ["signIn", "signOut"])

export const fieldsMethods = mapActions("fields", ["fetchGroupFields"])
